import { render, staticRenderFns } from "./ESGTemp.vue?vue&type=template&id=148e8686"
import script from "./ESGTemp.vue?vue&type=script&lang=js"
export * from "./ESGTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports